import React, { useState, useLayoutEffect } from "react";
import OpenLayerSource from "./OpenLayerSource";
import { GridStack } from "gridstack";
import Draw from "ol/interaction/Draw.js";
import "ol/ol.css";
import "./RTIncidentDashboard.css";

const RTIncidentDashboard = () => {
  // Default map center & zoom
  const center = { lat: 25.74755419155397, lng: 85.56225740541943 };
  const zoom = 8;

  // Map and layer source references
  const [map, setMap] = useState();
  const [source, setSource] = useState();
  const [draw, setDraw] = useState();

  // GridStack layout options
  const options = {
    staticGrid: true,
    column: 24,
  };

  /**
   * Callback passed to OpenLayerSource to get map & source instances
   */
  const setMapInstance = (mapInstance, sourceInstance) => {
    setMap(mapInstance);
    setSource(sourceInstance);
  };

  /**
   * Initialize GridStack layout on first render
   */
  useLayoutEffect(() => {
    GridStack.init(options);
  }, []);

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      {/* Map container */}
      <div
        className="grid-stack-item"
        gs-x="0"
        gs-y="0"
        gs-w="12"
        gs-h="13"
        key="0"
      >
        <div className="grid-stack-item-content grid-item">
          <OpenLayerSource zoom={zoom} center={center} onmapload={setMapInstance} />
        </div>
      </div>
    </div>
  );
};

export default RTIncidentDashboard;
